import {
  FaFolder,
  FaFile,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileImage,
  FaFileArchive,
  FaFileCode,
  FaFileAlt,
} from "react-icons/fa";

const FILE_ICON_RULES = [
  {
    match: (ct) => ct.includes("pdf"),
    icon: FaFilePdf,
    color: "#dc3545",
  },
  {
    match: (ct) => ct.includes("word") || ct.includes("wordprocessingml") || ct.includes("msword"),
    icon: FaFileWord,
    color: "#0d6efd",
  },
  {
    match: (ct) => ct.includes("excel") || ct.includes("spreadsheetml") || ct.includes("ms-excel"),
    icon: FaFileExcel,
    color: "#198754",
  },
  {
    match: (ct) => ct.includes("powerpoint") || ct.includes("presentationml") || ct.includes("ms-powerpoint"),
    icon: FaFilePowerpoint,
    color: "#fd7e14",
  },
  {
    match: (ct) => ct.includes("image"),
    icon: FaFileImage,
    color: "#0dcaf0",
  },
  {
    match: (ct) => ct.includes("zip") || ct.includes("compressed") || ct.includes("rar"),
    icon: FaFileArchive,
    color: "#fd7e14",
  },
  {
    match: (ct) => ct.includes("javascript") || ct.includes("json"),
    icon: FaFileCode,
    color: "#6f42c1",
  },
  {
    match: (ct) => ct.includes("text"),
    icon: FaFileAlt,
    color: "#6c757d",
  },
];

// MIME types that OnlyOffice Document Server can open (edit or view)
export const ONLYOFFICE_SUPPORTED_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/plain",
 // "application/pdf",
];

// MIME types where OnlyOffice supports full editing (not view-only)
export const ONLYOFFICE_EDITABLE_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/plain",
];

/**
 * Returns the appropriate React Icon component and color for a given drive asset.
 * @param {object} item - Drive asset with asset_type and content_type fields
 * @returns {{ icon: React.ComponentType, color: string }}
 */
export const useFileIcon = (item) => {
  if (item?.asset_type === "folder") {
    return { icon: FaFolder, color: "#1a73e8" };
  }

  const contentType = item?.content_type || "";
  const found = FILE_ICON_RULES.find(({ match }) => match(contentType));
  return found
    ? { icon: found.icon, color: found.color }
    : { icon: FaFile, color: "#6c757d" };
};
